export default __webpack_public_path__ + "static/Panasonic Outdoor-01e678dab94e2f21b492f131a0fb340d.jpg";